module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-2.a83908cf.JPG";